import React from "react";
import "./App.scss";
import MainPage from "./Views/MainPage";

function App() {
  return <MainPage />;
}

export default App;
